import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
/**
  * This component is used for archiving all the cards in a particular queue
  * 
  * User can archive the cards for a particular date or the user can archive all the cards before a particular date
*/
@Component({
  selector: 'app-archive-patient-popup',
  templateUrl: './archive-patient-popup.component.html',
  styleUrls: ['./archive-patient-popup.component.scss']
})
export class ArchivePatientPopupComponent implements OnInit {
  archiveCardForm: FormGroup;
  queueId;

  constructor(
    public dialogRef: MatDialogRef<ArchivePatientPopupComponent>,
    private FB: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public popup) {
      this.queueId = this.popup.queueId;
    }

  ngOnInit() {
    this.generateQueueForm();
  }

  generateQueueForm(){
    this.archiveCardForm = this.FB.group({
      queueId: [this.queueId, [Validators.required]],
      date: [new Date(), [Validators.required]],
      condition: ['eq', [Validators.required]]
    })
  }

  onSubmit(){
    if(this.archiveCardForm.valid){
      this.dialogRef.close({data: this.archiveCardForm.value});
    }
  }

}
